var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPageCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 399,
    viewBox: "0 0 399 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 129,
    rx: 136,
    ry: 135,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 129,
    rx: 119,
    ry: 118.125,
    fill: "#FFFFF6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 129,
    rx: 102,
    ry: 101.25,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 129,
    rx: 85,
    ry: 84.375,
    fill: "#FFFFF6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 129,
    rx: 68,
    ry: 67.5,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 129,
    rx: 51,
    ry: 50.625,
    fill: "#FFFFF6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 119,
    rx: 93,
    ry: 92,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 119,
    rx: 81.375,
    ry: 80.5,
    fill: "#FFFFF6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 119,
    rx: 69.75,
    ry: 69,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 119,
    rx: 58.125,
    ry: 57.5,
    fill: "#FFFFF6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 119,
    rx: 46.5,
    ry: 46,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 119,
    rx: 34.875,
    ry: 34.5,
    fill: "#FFFFF6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.5,
    cy: 324.5,
    rx: 75.5,
    ry: 74.5,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.5,
    cy: 324.5,
    rx: 66.0625,
    ry: 65.1875,
    fill: "#FFFFF6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.5,
    cy: 324.5,
    rx: 56.625,
    ry: 55.875,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.5,
    cy: 324.5,
    rx: 47.1875,
    ry: 46.5625,
    fill: "#FFFFF6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.5,
    cy: 324.5,
    rx: 37.75,
    ry: 37.25,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.5,
    cy: 324.5,
    rx: 28.3125,
    ry: 27.9375,
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPageCircles);
export default __webpack_public_path__ + "static/media/viewPageCircles.fb15c2f340a6970364cb4c5d03790a70.svg";
export { ForwardRef as ReactComponent };